"use client";

import { useState } from "react";
import "./index.scss";

const IS_NOTIFICATION_OPENED = true;

const NotificationClient = ({ text, href }: { text: string; href: string }) => {
  const [isOpened, setIsOpened] = useState(IS_NOTIFICATION_OPENED);

  if (isOpened === false || text.trim().length === 0) {
    return null;
  }

  return (
    <div className="component notification">
      <div className="notification-inner-wrapper">
        <div className="notification-content">
          {href && href.trim().length > 0 && (
            <a href={href} rel="noopener noreferrer">
              {text}
            </a>
          )}
          {(!href || href.length === 0) && text}
        </div>

        <div className="close">
          <a
            onClick={() => {
              window.IS_NOTIFICATION_OPENED = false;
              setIsOpened(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotificationClient;
